/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import PropTypes from "prop-types";
import classnames from "classnames";
import { createRoot } from "react-dom/client";
import s from "./index.module.scss";

/**
 * 弹窗
 * @param onConfirm
 * @param onCancel
 */
const Modal = ({
  onConfirm,
  onCancel,
  description,
  title,
  confirmTxt,
  cancelTxt,
  hideFooter,
  hasClose,
  showModal,
  setShowModal,
  icon,
  onClose,
}) => {
  const handleConfirm = () => {
    if (typeof onConfirm === "function") {
      onConfirm();
    } else {
      setShowModal(false);
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      Modal.hide();
    }
  };

  if (!showModal) {
    return null;
  }

  return (
    <section
      className={classnames({
        [s.modalContain]: true,
        [s.showModal]: showModal,
      })}
    >
      <div
        className={classnames({
          [s.modal]: true,
          [s.isClose]: hasClose,
          [s.noDesc]: !description,
        })}
      >
        {hasClose && <a className={s.close} onClick={handleClose} />}
        <div className={s.contentBox}>
          <div className={`${s.title} ${s[icon]}`}>{title}</div>
          {description && <div className={s.description}>{description}</div>}
        </div>
        {!hideFooter && (
          <div
            className={`${s.modalFooter} ${
              cancelTxt && confirmTxt && s.btnGroup
            }`}
          >
            {confirmTxt && (
              <a className={s.confirm} onClick={handleConfirm}>
                {confirmTxt}
              </a>
            )}
            {cancelTxt && (
              <a className={s.cancel} onClick={onCancel}>
                {cancelTxt}
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

let root;
/**
 * 渲染modal的方法
 * @param {{
 *  title: string;
 *  description?: string | ReactNode;
 *  confirmTxt?: string;
 *  cancelTxt?: string;
 *  onConfirm?: () => void;
 *  onCancel?: () => void;
 *  hasClose?: boolean;
 * }} props
 */
Modal.show = (props) => {
  let modelContainer = document.getElementById("modal");
  if (!modelContainer) {
    const div = document.createElement("div");
    div.setAttribute("id", "modal");
    modelContainer = div;

    document.body.appendChild(div);
  }
  root = createRoot(modelContainer);
  root.render(
    <Modal
      confirmTxt="确定"
      cancelTxt="取消"
      {...props}
      showModal
      onConfirm={() => {
        root.unmount();
        modelContainer.remove();
        props.onConfirm?.();
      }}
      onCancel={() => {
        root.unmount();
        modelContainer.remove();
        props.onCancel?.();
      }}
    />
  );
  return {
    close: () => {
      root.unmount();
      modelContainer.remove();
    }
  };
};

Modal.hide = () => {
  // 存在则卸载
  root?.unmount();
  root = undefined;

  // 清理 modal 容器，避免在同一容器上重复创建 root
  const modalContainer = document.getElementById("modal");
  if (modalContainer) {
    modalContainer.remove();
  }
};

Modal.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.element,
  ]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  confirmTxt: PropTypes.string,
  cancelTxt: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hideFooter: PropTypes.bool,
  hasClose: PropTypes.bool,
  onClose: PropTypes.func,
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func,
  icon: PropTypes.string,
};

Modal.defaultProps = {
  title: "确认退出吗？",
  description: "",
  confirmTxt: "",
  cancelTxt: "",
  onConfirm: null,
  onCancel: null,
  type: "web",
  hideFooter: false,
  hasClose: false,
  onClose: null,
  setShowModal: () => {},
  icon: "",
};

export default Modal;
